import { useState } from "react";
import { toast } from "sonner";
import { Download, FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { api } from "../../lib/api";

// CEO 2026-10-09 · Export 1 clic de tous les Codes RD (Excel ou PDF).
export default function CodeRdExportButton() {
    const [busy, setBusy] = useState(null);

    const download = async (format) => {
        setBusy(format);
        try {
            const res = await api.get("/admin/code-rd/registry/export", { params: { format }, responseType: "blob" });
            const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1]
                || `codes-rd.${format}`;
            const url = URL.createObjectURL(res.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 2000);
            toast.success(`Export ${format === "pdf" ? "PDF" : "Excel"} téléchargé`);
        } catch {
            toast.error("Export impossible, réessayez");
        } finally {
            setBusy(null);
        }
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    disabled={!!busy}
                    data-testid="code-rd-export-btn"
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-shariti-orange text-white text-xs font-black uppercase tracking-wider hover:bg-shariti-orange/90 transition disabled:opacity-60"
                >
                    {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
                    Exporter
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem onClick={() => download("xlsx")} data-testid="code-rd-export-xlsx">
                    <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" /> Excel (.xlsx)
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => download("pdf")} data-testid="code-rd-export-pdf">
                    <FileText className="w-4 h-4 mr-2 text-red-500" /> PDF
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
